import CompanySearchService from '@treasury/domain/backoffice/services/company/company-search-service';

export default class AlternateSearchClient {
    async fetchNotOnboardedCompanies(parameters: any) {
        return CompanySearchService.fetchNotOnboardedCompanies(parameters);
    }
}
